import React from 'react';

import { DropdownControlProps } from './DropdownControl.interfaces';
import {
  SelectControl,
  SelectWithFilterControl,
} from 'app/components/Controls';
import { useDropdownControl } from 'app/shared/hooks/controls/useDropdownControl';

export default function DropdownControl(props: DropdownControlProps) {
  const { handleClick, isMobile } = useDropdownControl(props);

  const DropdownControlComponent: React.ElementType = isMobile
    ? SelectControl
    : SelectWithFilterControl;

  return (
    <DropdownControlComponent
      {...props}
      onClick={handleClick}
      native={isMobile}
    />
  );
}
